/* Church Sign Shop — breadcrumb product-line switcher (snippets/crumb-switcher
   .liquid). A disclosure: toggles the popover, closes on Esc, outside click
   and blur-out. On phones the popover is styled as a bottom sheet, so the
   backdrop closes it too. */
(function () {
  function init(root) {
    var btn = root.querySelector('[data-crumbsw-btn]');
    var menu = root.querySelector('[data-crumbsw-menu]');
    if (!btn || !menu) return;

    function open(state) {
      menu.hidden = !state;
      btn.setAttribute('aria-expanded', state ? 'true' : 'false');
      root.classList.toggle('is-open', !!state);
      document.body.classList.toggle('crumbsw-open', !!state && window.matchMedia('(max-width: 767px)').matches);
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      open(menu.hidden);
    });
    document.addEventListener('click', function (e) {
      if (!menu.hidden && !root.contains(e.target)) open(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) { open(false); btn.focus(); }
    });
  }
  function boot() {
    document.querySelectorAll('[data-crumbsw]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
